import Section from '@components/common/Section/Section'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import React, { FC } from 'react'

import styles from './RichTextColumn.module.scss'

interface RichText {
  richText: string
  maxWidth?: number
}

type RichTextColumnProps = {
  columns?: RichText[]
  includeLineTop?: boolean
  includeLineBottom?: boolean
  maxWidth?: number
}

const RichTextColumn: FC<RichTextColumnProps> = ({
  columns,
  includeLineTop,
  includeLineBottom,
  maxWidth,
}) => {
  return (
    <Section>
      <div
        className={`${styles.container} ${includeLineTop && styles.lineTop} ${
          includeLineBottom && styles.lineBottom
        }`}
      >
        <div
          className={styles.wrapper}
          style={{ maxWidth: maxWidth ? `${maxWidth}%` : '100%' }}
        >
          {columns &&
            columns.map((column, index) => (
              <TrustedHtml
                key={index}
                className={styles.column}
                style={{
                  overflow: 'hidden',
                  width: `${100 / columns.length}%`,
                  margin: column.maxWidth
                    ? `0 ${(100 - column.maxWidth) / 2}%`
                    : '0',
                }}
                html={column.richText}
              />
            ))}
        </div>
      </div>
    </Section>
  )
}

export default RichTextColumn
